import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TicketMapperService } from 'src/app/shared/service/ticket-client/tickets-mapper.service';
import { TicketFromClientDetailBase } from 'src/app/shared/service/ticket-from-client/ticket-from-client-detail.base';
import { ActorType, Ticket, TicketCategory, TicketGetResponse } from 'src/app/shared/models/tickets/ticket.model';
import { TicketFromClientRepository } from '../../domain/repository/ticket-from-client.repository';
import { TicketFromClientRegisterPayload } from '../../domain/models/ticket-from-client.model';
import { TicketFromClientDetailMapperService } from '../mappers/ticket-from-client-detail-mapper.service';

@Injectable()
export class HttpTicketFromClientRepository extends TicketFromClientDetailBase implements TicketFromClientRepository {
  private readonly mapper = inject(TicketMapperService);
  private readonly ticketDetailMapper = inject(TicketFromClientDetailMapperService);

  protected toTicketDetail(ticket: TicketGetResponse): Ticket {
    return this.ticketDetailMapper.toTicketDetail(ticket);
  }

  register(payload: TicketFromClientRegisterPayload): Observable<{ recordIdTicket: string }> {
    return this.ticketClientApi.createTicket({
      recordIdConstitucion: payload.constitutionRecordId,
      tipoIncidencia: [this.mapper.reverseMapIncidentType(payload.incidentType)],
      descripcion: payload.description,
      categoriaTicket: TicketCategory.FROM_CLIENT,
      actorCreador: ActorType.CC_AGENT,
      reportador: payload.reporter,
      asesorAsignado: payload.assignedAdvisor,
    }).pipe(
      map(response => ({ recordIdTicket: response.ticketRecordId })),
    );
  }

}
